import { useTranslation } from 'react-i18next';
import LayoutStatusPage from '../../components/LayoutStatusPage';
import { useTheme } from '@mui/material';
import { Helmet } from 'react-helmet-async';

const NotFound = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <LayoutStatusPage
        imgUrl={theme.palette.mode === 'dark' ? 'danger.png' : 'danger.png'}
        title={t('not_found.title')}
        text={t('not_found.first_text')}
        secondText={t('not_found.second_text')}
        routerBack="/"
      />
    </>
  );
};
export default NotFound;
